<script setup lang="ts">
interface ImageItem {
  src: string;
  alt?: string;
  caption?: string;
}

interface Props {
  images: ImageItem[];
  itemsToShow?: number;
  autoplay?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  itemsToShow: 3,
  autoplay: false,
});
</script>

<template>
  <div class="image-carousel">
    <CarouselBase
      :items-to-show="itemsToShow"
      :autoplay="autoplay"
      :gap="12"
    >
      <CarouselSlide
        v-for="(image, i) in images"
        :key="i"
        :width="`${100 / itemsToShow}%`"
      >
        <div class="image-carousel__item">
          <img
            :src="image.src"
            :alt="image.alt || ''"
            class="image-carousel__img"
            loading="lazy"
            decoding="async"
          />
          <p
            v-if="image.caption"
            class="image-carousel__caption"
          >
            {{ image.caption }}
          </p>
        </div>
      </CarouselSlide>
    </CarouselBase>
  </div>
</template>

<style lang="scss">
.image-carousel {
  padding: 0 1% 0.5rem;
  cursor: pointer;
  &__wrapper {
    &--slide {
      cursor: pointer;
      @media (max-width: $tablet) {
        padding: 20% 0;
      }
      &:hover {
        transform: scale(1.2);
      }
    }
  }
  .Vuecarousel-slide {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
    &:hover {
      transform: scale(1.02);
      p {
        border-bottom: 5px solid var(--color-pink-1);
      }
    }
    img {
      border-radius: var(--radius);
      cursor: pointer;
      width: 3rem;
      margin: 0 auto -10px;
    }
    p {
      width: 100%;
      text-align: center;
      cursor: pointer;
      border-bottom: 5px solid transparent;
      padding-bottom: 5px;
      font-size: 0.7rem !important;
      @media (max-width: $tablet) {
        font-size: 0.7rem !important;
      }
    }
  }
  .greyed {
    opacity: 0.2;
  }
}
</style>
